import React from 'react';
import styled from 'styled-components';

type LegalPageLayoutProps = {
  title: string;
  updatedOn?: string;
  children: React.ReactNode;
};

const Container = styled.div`
  padding: 40px 24px 80px;
  max-width: 900px;
  margin: 0 auto;
  color: #1f2933;
  font-family: 'Hanken Grotesk', sans-serif;
  line-height: 1.7;
`;

const Header = styled.header`
  margin-bottom: 32px;
  text-align: left;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 8px;
  color: #111827;
`;

const UpdatedText = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 24px 0 32px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 16px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 28px 0 10px;
  color: #111827;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
  letter-spacing: 0.01em;
`;

const Strong = styled.span`
  font-weight: 600;
`;

const Paragraph = styled.p`
  margin: 0;
  color: #374151;
  font-weight: 400;

  strong,
  ${Strong} {
    font-weight: 600;
  }
`;

const List = styled.ul`
  margin: 0;
  padding-left: 20px;
  color: #374151;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ListItem = styled.li`
  margin: 0;
`;

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({
  title,
  updatedOn,
  children,
}) => (
  <Container>
    <Header>
      <Title>{title}</Title>
      {updatedOn && <UpdatedText>Updated: {updatedOn}</UpdatedText>}
    </Header>
    <Divider />
    <Content>{children}</Content>
  </Container>
);

export {
  LegalPageLayout,
  SectionTitle,
  Paragraph,
  List,
  ListItem,
  Strong,
};

